<span
  *ngIf="primaryFlag as flag"
  class="dq-pill"
  [class.dq-pill--warn]="variant === 'warn'"
  [class.dq-pill--info]="variant === 'info'"
  [class.dq-pill--neutral]="variant === 'neutral'"
  [attr.aria-label]="label"
  [title]="label">
  {{ label }}
</span>
